import { HONOR_LIST } from '../index.js';
import HonourCard from './HonourCard';
export default {
  components: {
    HonourCard
  },
  data() {
    return {
      honorList: HONOR_LIST,
      translateX: 0
    };
  },
  methods: {
    handleClickLeft() {
      if (this.translateX < 0) {
        this.translateX += 320;
      } else {
        this.translateX = -1600;
      }
    },
    handleClickRight() {
      if (this.translateX > -1600) {
        this.translateX -= 320;
      } else {
        this.translateX = 0;
      }
    }
  }
};